import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../../../../Services/axiosCommon'
import NuDate from '../../../../../../Components/Utils/NuDate'

function ViewHistory({open,onClose,Id}) {
    const [data, setData] = useState([])
    useEffect(() => {
        if (open) {
         GetFunction(Id)
        }
    },[Id,open])

    function GetFunction(id){
        axiosInstance.get(`/installation/history/${id}`).then(res => {
            console.log("res",res?.data?.data);
            setData(res?.data?.data)
        }).catch(err=>{
            console.log("err",err);
            
        })
    }
  return (
    <Modal open={open} title='Installation History' width={'40%'} centered onCancel={onClose} footer={[]}>
        <div className='w-full max-h-[75vh] p-2 overflow-y-auto'>
            <table className=' w-full border-collapse sticky top-0' >
                <thead className=' w-full bg-[#2A475E] text-white font-semibold text-xs'>
                    <tr>
                        <th className=' py-2 pl-1 text-left w-[50%]' style={{borderRight: "1px solid #FFFFFF" }}>Date</th>
                        <th className=' py-2 pl-1 text-left w-[50%]'>Completed Qty </th>
                    </tr>
                </thead>
            </table>
            <table className=' w-full border-collapse'>
                <tbody className=' w-full'>
                    {
                       data && data.map((item, index) => {
                        console.log("data",item);
                        
                            return (
                                <tr key={index} className=' bg-slate-50' style={{border: "1px solid #E9E8EC" }}>
                                    <td className="py-2 pl-1 text-left w-[50%] text-xs" style={{borderRight: "1px solid #E9E8EC" }}>{item?.date && <NuDate value={item?.date} format="DD-MMM-YYYY" />}</td>
                                    <td className="py-2 pl-1 text-left w-[50%] text-xs">{item?.completed}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    </Modal>
  )
}

export default ViewHistory